module.exports = __webpack_public_path__ + "img/feature-robot.423183d1.png";